import { isValidEmailAddress, isValidPassword } from '../functions';
import shoppingCartSidebar from './sidebar-cart';
//import Swal from 'sweetalert2'


$(document).ready(function() {

	$(document).on('click', '.page-product-add-qty-btn', function(e) {
		e.preventDefault();

		var qty = $('.page-product-qty').val();

		$('.page-product-qty').val(1*qty + 1);
	});

	$(document).on('click', '.page-product-remove-qty-btn', function(e) {
		e.preventDefault();

		var qty = 1*$('.page-product-qty').val();

		if (qty > 1) {
			qty = qty - 1;
		}

		$('.page-product-qty').val(qty);
	});

	var isLoadingAddToCart2 = false;
	$(document).on('click', '.page-product-add-to-cart-btn', function(e) {
        e.preventDefault();

		if (isLoadingAddToCart2) { return false; }

		var element = this;
        var id = $(this).data('id');
        if (!id) { console.log('invalid-id'); return false; }

		var qty = $('#qty').val();
		if (1*qty < 1) {
			alert('Invalid quantity!');
			return false;
		}

		isLoadingAddToCart2 = true;
		$(element).find('i').show();

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");;
        values += '&id=' + id;
        values += '&qty=' + qty;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/add",
            data: values,
            success: function(response) {
				isLoadingAddToCart2 = false;
				$(element).find('i').hide();

                if (response.status == 1) {
                    //window.location = baseURL + "/cart";
					$('.header-cart-counting').text(response.cart_items_count);

					if (response.cart_items_count > 0) {
						$('#header-cart').find('.rounded-circle').show();
					} else {
						$('#header-cart').find('.rounded-circle').hide();
					}

					$('.products-in-cart').show().find('span').text(response.product.qty);

					shoppingCartSidebar.refresh();

					/*Swal.fire({
						width: "350px",
						//icon: "success",
						title: "Success!",
						html: response.message
					});*/

					return;
                }

				Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {
				isLoadingAddToCart2 = false;
				$(element).find('i').hide();
            }
        });
    });

	$(document).on('click', '.product-add-qty-btn', function(e) {
		e.preventDefault();

		var id = $(this).data('id');
		var qty = $('#product-qty-' + id).text();

		$('#product-qty-' + id).text(1*qty + 1);
	});

	$(document).on('click', '.product-remove-qty-btn', function(e) {
		e.preventDefault();

		var id = $(this).data('id');
		var qty = 1*$('#product-qty-' + id).text();

		if (qty > 1) {
			qty = qty - 1;
		}

		$('#product-qty-' + id).text(qty);
	});

	var isLoadingAddToCart = false;
	$(document).on('click', '.products-list-add-to-cart-btn', function(e) {
        e.preventDefault();

		if (isLoadingAddToCart) { return false; }

		var element = this;
        var id = $(this).data('id');
        if (!id) { console.log('invalid-id'); return false; }

		// var qty = $('#product-qty-' + id).text();
		// if (1*qty < 1) {
		// 	alert('Invalid quantity!');
		// 	return false;
		// }
		var qty = 1;

		isLoadingAddToCart = true;
		$(element).find('i').show();

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");;
        values += '&id=' + id;
        values += '&qty=' + qty;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/add",
            data: values,
            success: function(response) {
				isLoadingAddToCart = false;
				$(element).find('i').hide();

                if (response.status == 1) {
                    //window.location = baseURL + "/cart";
					
					$('.header-cart-counting').text(response.cart_items_count);
					if (response.cart_items_count > 0) {
						$('#header-cart').find('.rounded-circle').show();
					} else {
						$('#header-cart').find('.rounded-circle').hide();
					}
					/*Swal.fire({
						width: "350px",
						//icon: "success",
						title: "Success!",
						html: response.message
					});*/

					$(element).find('span').text($(element).data('in-cart-text') + ' ('+response.product.qty+')');

					shoppingCartSidebar.refresh();
					
					return;

					// $(element).addClass('sendtocart');
					// setTimeout(function(){
					// 	$(element).removeClass('sendtocart');
					// 	// cart.addClass('shake').attr('data-totalitems', newCartTotal);
					// 	// setTimeout(function(){
					// 	// 	cart.removeClass('shake');
					// 	// },500)
					// },1000);
                }

				Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {
				isLoadingAddToCart = false;
				$(element).find('i').hide();
            }
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/products.js